"use client"

import { useSite } from "@/contexts/site/site.context"
import { mapToBcp47Locale } from "@/ts/locale/map-to-bcp47-locale"

type PriceProps = {
  readonly price: number
  readonly currency: string | null
  readonly className?: string
}

export function Price({ className, price, currency = null }: PriceProps) {
  const { locale } = useSite()

  const numberLocale = mapToBcp47Locale(locale)
  const formattedPrice = new Intl.NumberFormat(numberLocale, {
    currency: currency !== null ? currency : undefined,
    style: currency !== null ? "currency" : undefined,
  }).format(price)

  return (
    <div className={className} data-testid="price">
      {formattedPrice}
    </div>
  )
}
